import React from 'react';

import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { Component as Price } from '../ExtendedPrice';

import { NewCartDrawerProgressBar } from './NewCartDrawerProgressBar';
import { useCartDrawerPromoProgressBar } from './useCartDrawerProgressBar';

const CongratsSubHeading = styled.p`
  ${({ theme }) => theme.subHeader.variants.subHeading5Uppercase};
`;

const ProgressParagraph = styled.p`
  ${({ theme }) => theme.paragraph.variants.paragraph5Uppercase};
`;

const CongratsMessage = () => (
  <CongratsSubHeading>
    <FormattedMessage
      id="global_checkout.free_shipping_congratulation"
      defaultMessage="Congrats! You get Free Shipping."
    />
  </CongratsSubHeading>
);

const ProgressMessage = ({ amount }) => (
  <FormattedMessage
    id="global_checkout.away_from_gwp_message_p1"
    defaultMessage="{price} away from a {freeGift}"
    values={{
      price: (
        <ProgressParagraph>
          <Price amount={amount} />
        </ProgressParagraph>
      ),
      freeGift: (
        <ProgressParagraph>
          <FormattedMessage
            id="global_checkout.away_from_gwp_message_p2"
            defaultMessage="free gift!"
          />
        </ProgressParagraph>
      ),
    }}
  />
);

export function NewCartDrawerPromoProgressBar() {
  const { shouldShowProgressBar, total, threshold } =
    useCartDrawerPromoProgressBar();

  if (!shouldShowProgressBar) {
    return null;
  }
  if (total >= threshold) {
    return (
      <NewCartDrawerProgressBar
        progress={{ currentValue: total, goalValue: threshold }}
        render={<CongratsMessage />}
      />
    );
  }
  return (
    <NewCartDrawerProgressBar
      progress={{ currentValue: total, goalValue: threshold }}
      render={({ amountToGoal }) => <ProgressMessage amount={amountToGoal} />}
    />
  );
}
